import { createSlice } from '@reduxjs/toolkit';
import { PAGELENGTH } from 'components/common/ListLayout';
import Api from "services/api";

export const initialState = {
  holidayRates: [],
  error: null,
  loader: false,
  total: 0,
  is_more: false,
  current_page: 1,
  per_page: PAGELENGTH,
  last_page: 1
};

export const holidayRatesSlice = createSlice({
  name: 'holidayRates',
  initialState,
  reducers: {
    setHolidayRates: (state, { payload }) => {
      state.holidayRates = payload?.data ?? payload;
      state.total = payload?.total;
      state.is_more = payload?.is_more;
      state.last_page = payload?.last_page;
      state.current_page = payload?.current_page;
      state.per_page = payload?.per_page;
    },
    setError: (state, { payload }) => {
      state.error = payload;
    },
    setLoader: (state, { payload }) => {
      state.loader = payload;
    },
    updateHolidayRateStatus: (state, { payload }) => {
      const { id, status } = payload;
      const rate = state.holidayRates.find((r) => r.id === id);
      if (rate) {
        rate.status = status;
      }
    }
  }
});

// --------------------------
// Thunks
// --------------------------

// Fetch all holiday rates
export const fetchHolidayRates = (page, params, disableLoader, Aync) => async (dispatch) => {
  !disableLoader && dispatch(setLoader(true));
  try {
    const result = await Api.fetchHolidayRates(page, params);
    if (result.status >= 200 && result.status < 300) {
      if (Aync) {
        return result?.data?.data;
      } else {
        dispatch(setHolidayRates(result.data));
      }
    } else if (result?.status === 422) {
      if (Aync) {
        return [];
      } else {
        dispatch(setError(result.data));
      }
    }
  } catch (error) {
    console.log("error", error);
  }
  !disableLoader && dispatch(setLoader(false));
};

export const addHolidayRate = (data, callback) => async (dispatch) => {
  dispatch(setError({}));
  dispatch(setLoader(true));
  try {
    const json = await Api.addHolidayRate(data); // ensure this API method exists
    console.log("API RESPONSE", json);
    if (json.status >= 200 && json.status < 300) {
      callback(true, json.data.message);
    } else if (json.status === 422) {
      dispatch(setError(json.data));
      callback(false, json.data.message);
    } else {
      callback(false, json.data?.message || 'Something went wrong');
    }
  } catch (error) {
    console.log(error);
    callback(false, error.response?.data?.message || error.message || 'Request failed');
  }
  dispatch(setLoader(false));
};

// Update Holiday Rate
export const updateHolidayRate = (data, itemId, callback) => async (dispatch) => {
  dispatch(setError({}));
  dispatch(setLoader(true));
  try {
    const json = await Api.updateHolidayRate(data, itemId); // ensure this API method exists
    if (json.status >= 200 && json.status < 300) {
      callback(true, json.data.message);
    } else if (json.status === 422) {
      dispatch(setError(json.data));
      callback(false, json.data.message);
    } else {
      callback(false, json.data?.message || 'Something went wrong');
    }
  } catch (error) {
    console.log(error);
    callback(false, error.response?.data?.message || error.message || 'Request failed');
  }
  dispatch(setLoader(false));
};

// Change holiday rate status
export const changeHolidayRateStatus = (id, data) => async (dispatch) => {
  dispatch(setError({}));
  dispatch(setLoader(true));
  try {
    const json = await Api.statusChange(id, data, 'holiday-rates');
    if (json.status >= 200 && json.status < 300) {
      dispatch(updateHolidayRateStatus({ id, status: data.status }));
    } else {
      dispatch(setError(json.data));
    }
  } catch (error) {
    console.log(error);
  }
  dispatch(setLoader(false));
};

// Remove multiple holiday rates
// slices/holidayRateSlice.js
export const removeMultipleHolidayRates = (payload, callback) => async (dispatch) => {
  dispatch(setLoader(true));
  try {
    const res = await Api.removeMultipleHolidayRates(payload); // 👈 yahan ab function milega
    if (res?.data?.success) {
      callback(true, res?.data?.message);
      dispatch(fetchHolidayRates());
    } else {
      callback(false, res?.data?.message || "Failed to delete");
    }
  } catch (err) {
    callback(false, "Something went wrong");
  } finally {
    dispatch(setLoader(false));
  }
};

// --------------------------
// Exports
// --------------------------
export const { setHolidayRates, setLoader, setError, updateHolidayRateStatus } = holidayRatesSlice.actions;

export default holidayRatesSlice.reducer;

// Selector
export const holidayRatesSelector = (state) => state.holidayRates;
